import { createContext } from "react";
import LocalizedStrings from "react-localization";
import enTranslations from "../translations/en.json";
import nlTranslations from "../translations/nl.json";

const strings = new LocalizedStrings({
  en: enTranslations,
  nl: nlTranslations,
});

export const LanguageContext = createContext({
  strings: strings,
  setLanguage: (lang: "nl" | "en") => {
    /* Implementation provided by LanguageProvider */
    return lang;
  },
  currentLang: "nl",
});
